import styled from 'styled-components';

export const FormStyled = styled.div`
  max-width: 328px;
  padding: 48px 44px 40px 44px;
  opacity: 0.9;
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  z-index: 1;
  align-self: center;
  .logo {
    text-align: center;
    margin-bottom: 16px;
    img {
      width: 75px;
    }
  }
  .intro {
    color: var(--black);
    font-family: var(--font-family);
    font-size: 16px;
    letter-spacing: 0;
    height: 16px;
    line-height: 24px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 32px;
  }
  .form {
    .ant-form-item {
      width: 240px;
      &.input-username {
        margin-bottom: 8px;
      }
      .ant-form-item-label {
        height: 24px;
        padding-bottom: 0px;
        label {
          font-size: 12px;
        }
      }
      .ant-form-item-control-input {
        border: unset;
        border-bottom: 1px solid var(--border-color-input);
        border-radius: unset;
        font-weight: 300;
        font-size: 16px;
        letter-spacing: 0;
        line-height: 20px;
        min-height: 40px;
        .ant-input-borderless {
          padding: 0px;
        }
        .ant-input {
          font-size: 16px;
          &[type='password'] {
          }
        }
        .ant-form-item-control-input-content {
          input {
            &::placeholder {
              color: #666666;
            }
          }
        }
      }
    }
    .btn-submit {
      width: 100%;
      text-align: center;
      border-radius: 4px;
      height: 48px;
      border: unset;
      color: var(--white);
      background: linear-gradient(135deg, #6fb8e1 0%, #1c4b8d 100%);
      font-size: 16px;
      letter-spacing: 0;
      line-height: 24px;
    }
    .btn-submit:disabled {
      opacity: 0.5;
    }
    .error-message {
      color: red;
    }
  }
  .form .ant-input-affix-wrapper {
    position: relative;
    padding: 0;
  }

  .form .ant-input-suffix {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
  }
`;

export default styled.section`
  display: flex;
  justify-content: center;
  min-height: 100vh;
  position: relative;

  .rectangle {
    // opacity: 0.5;
    // background: linear-gradient(180deg, #ffffff 0%, #0020ad 100%);
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .background {
    position: absolute;
    z-index: 0;
    width: 100vw;
    height: 100vh;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .policySty {
    background-color: transparent;
    border: 1px #ccc;
    outline: none;
    color: var(--white);
    font-size: 20px;
  }

  .supportInfoContainer {
    display: flex;
    position: absolute;
    bottom: 20px;
    justify-content: center;
    align-items: center;
  }
  .supportInfoBox {
    margin-left: 10px;
    font-size: 12px;
    line-height: 20px;
    border-radius: 20px;
    background-color: rgba(255, 255, 255, 0.9);
    padding: 10px;
    text-align: center;
    color: black;
    font-weight: bold;
  }

  .phoneNumber {
    color: red;
    font-weight: bold;
    font-size: 16px;
    text-decoration: underline;
  }

  .underLineText {
    text-decoration: underline;
  }

  .phoneIcon {
    width: 18px;
    height: 18px;
  }
`;
